import { gql } from '@apollo/client';
import Fragments from './fragments';
import CommonFragments from 'features/common/fragments';

export const CONTENT_TYPE_SAVED = gql`
  subscription contentTypeSaved {
    contentTypeSaved {
      contentType {
        ...contentType
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${Fragments.contentType}
  ${CommonFragments.messageHeaders}
`;

export const CONTENT_TYPE_X_METADATA_SAVED = gql`
  subscription contentTypeXMetadataSaved($id: Int) {
    contentTypeXMetadataSaved(id: $id) {
      isNew
      contentTypeXMetadata {
        id
        contentTypeId
        metadataId
        mandatory
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const CONTENT_TYPE_X_METADATA_DELETED = gql`
  subscription contentTypeXMetadataDeleted {
    contentTypeXMetadataDeleted {
      id
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const CONTENT_TYPE_X_USER_GROUPS_SAVED = gql`
  subscription contentTypeXUserGroupsSaved {
    contentTypeXUserGroupsSaved {
      contentTypeXUserGroups {
        ...contentTypeXUserGroup
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${Fragments.contentTypeXUserGroup}
  ${CommonFragments.messageHeaders}
`;
